<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <div v-if="false">
          <div style="display:inline-block;" data-aos="fade-in" data-aos-once="true">
            <a href="https://github.com/morph85">morph / <i class="fa fa-github" style="vertical-align:middle;"></i></a>
          </div>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <div style="display:inline-block;vertical-align:middle;" data-aos="fade-in" data-aos-once="true">
            <a href='https://ko-fi.com/A83439QF' target='_blank'><img height='26' style='border:0px;height:26px;' src='https://az743702.vo.msecnd.net/cdn/kofi2.png?v=0' border='0' alt='Buy Me a Coffee at ko-fi.com' /></a>
          </div>
        </div>
        <div class="footer-wraper">
          <div class="footer-block left brace" style="margin-right:15px;">
            <div>
              <a href="https://www.facebook.com/noctorus.studio" target="_blank">
                <i class="fa fa-facebook"></i>
              </a>
            </div>
            <div>
              <a href="https://www.twitter.com/noctorus" target="_blank">
                <i class="fa fa-twitter"></i>
              </a>
            </div>
            <div>
              <a href="https://www.medium.com/@noctorus" target="_blank">
                <i class="fa fa-medium"></i>
              </a>
            </div>
            <div>
              <a href="https://www.github.com/morph85" target="_blank">
                <i class="fa fa-github"></i>
              </a>
            </div>
          </div>
          <div class="footer-block left brace">
            <span class="left-brace-tl"></span>
            <span class="left-brace-tr"></span><br />
            <span class="left-brace-bl"></span>
            <span class="left-brace-br"></span>
          </div>
          <div class="footer-block left">
            <i class="ficon fa fa-code"></i>
            <div class="fname">
              <strong>noctorus</strong> &copy; 2017.
            </div>
          </div>
          <div class="footer-block right">
            <div>
              <a href="/privacy">Privacy Policy</a>
            </div>
            <div>
              <a href="/terms">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footer',
  components: {
  },
  data () {
    return {

    }
  },
  methods: {
    sample (data) {

    }
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.footer {
  padding: 1.5rem 2rem 2rem; // top left/right btm
  color: $color-gray;

  .footer-wraper {
    display: block;
    clear: both;
    margin: 15px;

    .footer-block {
      padding: 3px 5px;
      display: inline-block;
      vertical-align: middle;

      .ficon {
        margin-right: 15px;
        vertical-align: middle;
      }

      .fname {
        display: inline-block;
        vertical-align: middle;
      }

      &.left {
        border-right: 1px solid lightgray;
        padding-right: 15px;
      }

      &.brace {
        border-right: 0;
        height: 100px;
        padding-right: 0;

        // curly bracket
        span {
          width: 10px;
          height: 30px;
          display: inline-block;
        }
        .left-brace-tl {
          border-right: 1px solid darkgray;
          border-bottom-right-radius: 10px;
          margin-right:-6px;
          margin-top: 10px;
          margin-bottom: -6px; // configure: close top gap
        }
        .left-brace-tr {
          margin-top: 4px; // configure: go btm
          margin-bottom: 10px;
          border-left: 1px solid darkgray;
          border-top-left-radius: 10px;
        }
        .left-brace-bl {
          margin-top: 0px; // configure: close btm gap
          border-right: 1px solid darkgray;
          border-top-right-radius: 10px;
          margin-right: -6px;
        }
        .left-brace-br {
          margin-bottom: -8px;
          border-left: 1px solid darkgray;
          border-bottom-left-radius: 10px;
        }
      }

      &.right {
        vertical-align: middle;
        padding-left: 10px;

        div {
          padding: 0;
          margin: 0;
          line-height: 1em;
          text-align: left;

          a {
            font-size: 0.6em;
            border-bottom: 1px solid gray;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Footer.vue?30b65c40